// extracted by mini-css-extract-plugin
export default {"root":"SmallView-root","section":"SmallView-section","descriptionStatus":"SmallView-descriptionStatus","statusCode":"SmallView-statusCode"};